import { z } from 'zod';
import { AccountJSONSchema } from './accounts/account';

export const OrganizationJSONSchema = z.object({
	accounts: z.array(AccountJSONSchema),
	id: z.uuidv4(),
	name: z.string(),
});

export type IOrganizationJSON = z.infer<typeof OrganizationJSONSchema>;
